// extracted by mini-css-extract-plugin
module.exports = {"button":"MenuButton__button___1z_i0","triangle":"MenuButton__triangle___3ydaS","active":"MenuButton__active___2PZMy"};